import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { errorAction, types as at } from "@authzsvc/api-lib";
import {
  getMyRequests,
  getRequestsToApprove,
  approveRequest,
  denyRequest,
} from "../../actions/api";
import { isApiCallLoading } from "../../selectors";
import { Requests } from "@authzsvc/common-react-components";
import * as antd from "antd";
import { showErrorNotification, showSuccessNotification } from "../../util";

const RequestsWrapper = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const myRequests = useSelector((state) => state.requests.my);
  const toApprove = useSelector((state) => state.requests.toApprove);

  const loadingMyRequests = useSelector((state) =>
    isApiCallLoading(state, at.GET_REQUESTS)
  );
  const loadingToApprove = useSelector((state) =>
    isApiCallLoading(state, at.GET_REQUESTS_TO_APPROVE)
  );

  useEffect(() => {
    dispatch(getMyRequests());
    dispatch(getRequestsToApprove());
  }, [dispatch]);

  const handleSelect = (request) => {
    if (request) {
      navigate(`/requests/${request.id}`);
    }
  };

  const handleRefresh = () => {
    dispatch(getMyRequests());
    dispatch(getRequestsToApprove());
  };

  const handleApprove = async (request, reason) => {
    const resp = await dispatch(approveRequest(request.id, reason || ""));
    if (resp.type === errorAction(at.APPROVE_REQUEST)) {
      showErrorNotification(resp.payload.title, resp.payload.data.message);
    } else {
      showSuccessNotification("Success", "The request has been approved.");
      handleRefresh();
    }
  };

  const handleDeny = async (request, reason) => {
    const resp = await dispatch(denyRequest(request.id, reason));
    if (resp.type === errorAction(at.DENY_REQUEST)) {
      showErrorNotification(resp.payload.title, resp.payload.data.message);
    }
    showSuccessNotification("Success", "The request has been denied.");
    handleRefresh();
  };

  return (
    <antd.Card
      style={{
        maxWidth: "50%",
        margin: "2rem auto",
        padding: "2rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <antd.Row justify="center">
        <antd.Col span={24}>
          <Requests
            onSelect={handleSelect}
            myRequests={myRequests}
            toApprove={toApprove}
            loadingMyRequests={loadingMyRequests}
            loadingToApprove={loadingToApprove}
            onApprove={handleApprove}
            onDeny={handleDeny}
          />
        </antd.Col>
      </antd.Row>
    </antd.Card>
  );
};

export default RequestsWrapper;
